import React from 'react'

import ReactWhatsapp from "react-whatsapp";

import familyshopping from "../images/FAMILY SHOPPING PHOTO.jpg";
import BestSaree from "../images/FAMILY SHOPPING Image.jpg";
import familyfashion from "../images/FAMILY SHOPPING New photo.jpg";
import completefmilyshopping from "../images/FAMILY SHOP.jpg";




import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'






function FamilyShopping() {
    return (
        <div>

          
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={familyshopping} className="card-img-top" alt="familyshopping"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#CD0004" }} className="card-title mb-1">Family Collection </h5>
                                                <p  className="card-text">Complete Family Shopping Available </p>
                                              

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9064837572'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9064837572" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={BestSaree} className="card-img-top" alt="BestSaree"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#CD0004" }} className="card-title mb-1">Family Collection</h5>
                                                <p className="card-text">Complete Family Shopping Available</p>
                                   
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9064837572'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9064837572" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={familyfashion} className="card-img-top" alt="familyfashion at Balaji Saree"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#CD0004" }} className="card-title mb-1">Family Collection</h5>
                                                <p className="card-text">Complete Family Shopping Available </p>
                                   
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9064837572'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9064837572" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={completefmilyshopping} className="card-img-top" alt="completefmilyshopping"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5  style={{ color: "#CD0004" }} className="card-title mb-1" >Family Collection                 </h5>
                                                <p className="card-text">Complete Family Shopping Available</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9064837572'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9064837572" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>



            
           
            <br />

            <br />
        </div>
    )
}

export default FamilyShopping